export const FILE = "file";
export const FOLDER = "folder";
